import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSend"><Path d="M21.1276 4.76048C21.5025 3.59713 20.4032 2.49787 19.2399 2.87273L1.95798 8.44134C0.518557 8.90516 0.592321 10.9663 2.06122 11.326L10.292 13.3417C10.473 13.386 10.6143 13.5274 10.6587 13.7084L12.6744 21.9392C13.0341 23.4081 15.0952 23.4818 15.559 22.0424L21.1276 4.76048Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSend;
